import React, { Component } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

import { ESTILOS } from './Styles/StylesBeca';

class PlanillaBecaPag4 extends Component {
    render() {
        const styles = StyleSheet.create(ESTILOS[0]);
        let { requisitos } = this.props;

        let documentos = () => {
            let num = 0
            return(
                requisitos.map(option => {
                    num++
                    return(
                        <View style={[styles.row, {marginTop: 1}]} key={option.id}>
                            <Text style={[styles.colTabla30, styles.font8, styles.bordeLRB, styles.center]}>{num}</Text>
                            <Text style={[styles.colTabla420, styles.font8, styles.bordeLRB]}>{option.requisito}</Text>
                            <Text style={[styles.colTabla30, styles.font8, styles.bordeRB]}></Text>
                            <Text style={[styles.colTabla30, styles.font8, styles.bordeRB]}></Text>
                            <Text style={[styles.colTabla40, styles.font8, styles.bordeRB]}></Text>
                        </View>
                    )
                })
            )
        }

        let observaciones = () => {
            let contenido = []
            for (let i = 1; i < 6; i++){
                contenido.push(
                    <View style={[styles.row]}>
                        <Text style={[styles.colTabla280, styles.font8, styles.bordeLRB, {padding: 8}]}></Text>
                        <Text style={[styles.colTabla270, styles.font8, styles.bordeRB]}></Text>
                    </View>
                )
            }
            return contenido
        }

        return (
            <React.Fragment>
                <View style={[styles.borde, styles.custonMt10, {backgroundColor: "#FFF", padding: 4,}]}>
                    <View style={[{padding: 1, backgroundColor: "#fff"}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeAll, {backgroundColor: "#cecece", color:"#000"}]}>RECAUDOS</Text>
                        </View>
                        <View style={[styles.row, {marginTop: 1}]}>
                            <Text style={[styles.colTabla30, styles.font6, styles.bordeLRB, styles.center, {backgroundColor: "#cecece", color:"#000"}]}>ITEM</Text>
                            <Text style={[styles.colTabla420, styles.font8, styles.bordeLRB, {backgroundColor: "#cecece", color:"#000"}]}>DOCUMENTOS</Text>
                            <Text style={[styles.colTabla100, styles.font8, styles.bordeRB, {backgroundColor: "#cecece", color:"#000"}]}>FECHA CONSIGNACIÓN</Text>
                        </View>
                        {documentos()}
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.bordeLRBSP, {padding: 2}]}></Text>
                        </View>
                        <View style={[styles.row, {marginTop: 1}]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeLRT]}>
                                DECLARO QUE LA INFORMACIÓN SUMINISTRADA EN ESTAS PLANILLAS ES VERDADERA Y AUTORIZO A LA COORDINACIÓN DE ORIENTACIÓN Y BIENESTAR ESTUDIANTIL A COMPROBAR LA VERACIDAD DE LOS DATOS SUMINISTRADOS.
                            </Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeLRB]}>
                                ACEPTO CONOCER Y CUMPLIR LOS REGLAMENTOS DEL INSITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES Y QUE DE DEMOSTRARSE CUALQUIER INCONGRUENCIA O FALSEDAD CON LOS DATO SSUMINISTRADOS, ASUMIR LAS CONSECUENCIAS DE ORDEN LEGAL Y/O DISCIPLINARIO QUE DE ELLO SE DERIVEN
                            </Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla80, styles.font8, styles.bordeLRT]}></Text>
                            <Text style={[styles.colTabla240, styles.font8, styles.bordeRB]}>EL REPRESENTANTE O RESPONSABLE ECONÓMICO</Text>
                            <Text style={[styles.colTabla230, styles.font8, styles.bordeRB]}>EL ESTUDIANTE</Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla80, styles.font8, styles.bordeLR, styles.center]}>FIRMAN:</Text>
                            <Text style={[styles.colTabla240, styles.font8, styles.bordeR]}></Text>
                            <Text style={[styles.colTabla230, styles.font8, styles.bordeR]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla80, styles.font8, styles.bordeLRB, {padding: 8}]}></Text>
                            <Text style={[styles.colTabla240, styles.font8, styles.bordeRB]}></Text>
                            <Text style={[styles.colTabla230, styles.font8, styles.bordeRB]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.bordeLRBSP, {padding: 2}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeAll, {backgroundColor: "#cecece", color:"#000"}]}>SOLO PARA USO DE LA INSTITUCIÓN</Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.bordeLRBSP, {padding: 2}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeAll, {backgroundColor: "#cecece", color:"#000"}]}>COORDINACIÓN DE ORIENTACIÓN Y BIENESTAR ESTUDIANTIL</Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla280, styles.font8, styles.bordeLRB]}>OBSERVACIONES</Text>
                            <Text style={[styles.colTabla270, styles.font8, styles.bordeRB]}>RECOMENDACIONES</Text>
                        </View>
                        {observaciones()}
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeAll, {backgroundColor: "#cecece", color:"#000"}]}>CONSEJO ACADÉMICO</Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla280, styles.font8, styles.bordeLRB]}>OBSERVACIONES</Text>
                            <Text style={[styles.colTabla270, styles.font8, styles.bordeRB]}>RECOMENDACIONES</Text>
                        </View>
                        {observaciones()}
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.bordeLRBSP, {padding: 2}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla120, styles.font8, styles.bordeAll]}>DICTAMEN</Text>
                            <Text style={[styles.colTabla40, styles.font6, styles.bordeRT, {backgroundColor: "#cecece", color:"#000"}]}>APROBADA</Text>
                            <Text style={[styles.colTabla20, styles.font8, styles.bordeRT, styles.center]}></Text>
                            <Text style={[styles.colTabla270, styles.font8, styles.bordeRT, {backgroundColor: "#cecece", color:"#000"}]}>TIPO DE AYUDA</Text>
                            <Text style={[styles.colTabla80, styles.font7, styles.bordeRT, styles.center, {backgroundColor: "#cecece", color:"#000"}]}>INSCRIPCIÓN</Text>
                            <Text style={[styles.colTabla20, styles.font9, styles.bordeRTB, styles.center]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla60, styles.font8, styles.bordeLRB]}>FECHA</Text>
                            <Text style={[styles.colTabla60, styles.font8, styles.bordeRB]}>ACTA N°</Text>
                            <Text style={[styles.colTabla40, styles.font6, styles.bordeR, {backgroundColor: "#cecece", color:"#000"}]}>NEGADA</Text>
                            <Text style={[styles.colTabla20, styles.font8, styles.bordeRT, styles.center]}></Text>
                            <Text style={[styles.colTabla70, styles.font5, styles.bordeRT]}>FINANCIAMIENTO</Text>
                            <Text style={[styles.colTabla20, styles.font8, styles.bordeRT, styles.center]}></Text>
                            <Text style={[styles.colTabla70, styles.font5, styles.bordeRT]}>BECA TRABAJO</Text>
                            <Text style={[styles.colTabla20, styles.font8, styles.bordeRT, styles.center]}></Text>
                            <Text style={[styles.colTabla70, styles.font5, styles.bordeRT]}>BECA</Text>
                            <Text style={[styles.colTabla20, styles.font8, styles.bordeRT, styles.center]}></Text>
                            <Text style={[styles.colTabla100, styles.font7, styles.bordeR, styles.center, {backgroundColor: "#cecece", color:"#000"}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla60, styles.font8, styles.bordeLRB]}></Text>
                            <Text style={[styles.colTabla60, styles.font8, styles.bordeRB]}></Text>
                            <Text style={[styles.colTabla40, styles.font6, styles.bordeRB, {backgroundColor: "#cecece", color:"#000"}]}>DIFERIDA</Text>
                            <Text style={[styles.colTabla20, styles.font8, styles.bordeRTB, styles.center]}></Text>
                            <Text style={[styles.colTabla70, styles.font5, styles.bordeRTB]}>BECA A LA EXCELENCIA</Text>
                            <Text style={[styles.colTabla20, styles.font8, styles.bordeRTB, styles.center]}></Text>
                            <Text style={[styles.colTabla70, styles.font5, styles.bordeRTB]}>MEDIA BECA TRABAJO</Text>
                            <Text style={[styles.colTabla20, styles.font8, styles.bordeRTB, styles.center]}></Text>
                            <Text style={[styles.colTabla70, styles.font5, styles.bordeRTB]}>MEDIA BECA</Text>
                            <Text style={[styles.colTabla20, styles.font8, styles.bordeRTB, styles.center]}></Text>
                            <Text style={[styles.colTabla80, styles.font7, styles.bordeRB, styles.center, {backgroundColor: "#cecece", color:"#000"}]}>RENOCACIÓN</Text>
                            <Text style={[styles.colTabla20, styles.font9, styles.bordeRTB, styles.center]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.bordeLRBSP, {padding: 2}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeLRT, {padding: 5}]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla120, styles.font6, styles.bordeL, styles.right]}>FIRMA</Text>
                            <Text style={[styles.colTabla430, styles.font6, styles.bordeR, styles.center]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla120, styles.font6, styles.bordeL, styles.right]}>NOMBRE Y APELLIDO</Text>
                            <Text style={[styles.colTabla430, styles.font6, styles.bordeR, styles.center]}>SELLO</Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla120, styles.font6, styles.bordeL, styles.right]}>CARGO</Text>
                            <Text style={[styles.colTabla430, styles.font6, styles.bordeR, styles.center]}></Text>
                        </View>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTabla550, styles.font8, styles.bordeLRB, {padding: 5}]}></Text>
                        </View>
                    </View>
                </View>
            </React.Fragment>
        );
    }
}
 
export default PlanillaBecaPag4;


// WEBPACK FOOTER //
// ./src/components/Reportes/PlanillaBecaPag4.jsx